import { cartOrderPublicClient } from './client';

export interface PlanNutritionalFacts {
  id: number;
  caloriesInKcalMin: number;
  caloriesInKcalMax: number | null;
  cholesterolInMgMin: number;
  cholesterolInMgMax: number | null;
  dietaryFiberInGMin: number;
  dietaryFiberInGMax: number | null;
  netCarbsInGMin: number;
  netCarbsInGMax: number | null;
  proteinInGMin: number;
  proteinInGMax: number | null;
  saturatedFatInGMin: number;
  saturatedFatInGMax: number | null;
  servingSizeInOzMin: number;
  servingSizeInOzMax: number | null;
  sodiumInMgMin: number;
  sodiumInMgMax: number | null;
  sugarsInGMin: number;
  sugarsInGMax: number | null;
  totalCarbsInGMin: number;
  totalCarbsInGMax: number | null;
  totalFatInGMin: number;
  totalFatInGMax: number | null;
  addedSugarInGMin: number;
  addedSugarInGMax: number | null;
  calciumInMgMin: number;
  calciumInMgMax: number | null;
  ironInMgMin: number;
  ironInMgMax: number | null;
  potassiumInMgMin: number;
  potassiumInMgMax: number | null;
  vitaminDInMcgMin: number;
  vitaminDInMcgMax: number | null;
}

export interface PlanMealConfig {
  id: number;
  ingredientToAvoidIds: number[];
  tagIds: number[];
  nutritionalFacts: PlanNutritionalFacts;
}

export interface Plan {
  id: number;
  logicalId: string;
  displayName: string;
  description: string;
  mealQuantity: number;
  mealConfig: PlanMealConfig;
}

/**
 *
 * GET `/v1/public/plans`
 *
 * Fetches available plans from cart-order-svc.
 */
export const getPlans = async (): Promise<Plan[]> => {
  const { data } = await cartOrderPublicClient(1).get<Plan[]>('/plans');

  return data;
};
